import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_metronic/layout/core';
import { View } from './components/View';

const ProyectosPage: FC = () => {
  const breadCrumbs: Array<PageLink> = [];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Proyectos</PageTitle>
      <View />
    </>
  );
};

export { ProyectosPage };
